import { MapPin, Train, Building2, Car } from "lucide-react";

const landmarks = [
  "Kalyan Railway Station",
  "Khadakpada Circle",
  "Birla College Road",
  "Metro Junction Mall",
  "Murbad Road",
  "Shahad",
];

const areas = [
  "Kalyan", "Kalyan East", "Khadakpada", "Mohne",
  "Wayle Nagar", "Tisgaon", "Shahad", "Ambernath",
  "Ulhasnagar", "Dombivli", "Thakurli", "Diva",
];

const KalyanLocalSignals = () => (
  <section className="py-14 md:py-20 bg-card">
    <div className="container">
      <div className="text-center mb-10">
        <span className="text-eyebrow text-primary">Serving Kalyan & Around</span>
        <h2 className="font-heading text-2xl md:text-3xl font-light mt-2">
          Conveniently Located for Patients Across Kalyan
        </h2>
      </div>
      <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        <div className="bg-background rounded-xl p-6 border border-border">
          <div className="flex items-center gap-2 mb-3 text-primary">
            <Building2 className="h-5 w-5" />
            <h3 className="font-heading text-lg">Nearby Landmarks</h3>
          </div>
          <ul className="text-sm space-y-1.5 text-muted-foreground">
            {landmarks.map((l) => <li key={l}>• {l}</li>)}
          </ul>
        </div>
        <div className="bg-background rounded-xl p-6 border border-border">
          <div className="flex items-center gap-2 mb-3 text-primary">
            <MapPin className="h-5 w-5" />
            <h3 className="font-heading text-lg">Areas We Serve</h3>
          </div>
          <div className="flex flex-wrap gap-1.5">
            {areas.map((a) => (
              <span key={a} className="text-xs bg-secondary/50 text-secondary-foreground rounded-full px-2.5 py-1">{a}</span>
            ))}
          </div>
        </div>
        <div className="bg-background rounded-xl p-6 border border-border">
          <div className="flex items-center gap-2 mb-3 text-primary">
            <Car className="h-5 w-5" />
            <h3 className="font-heading text-lg">How to Reach</h3>
          </div>
          <ul className="text-sm space-y-2 text-muted-foreground">
            <li className="flex items-start gap-2"><Train className="h-4 w-4 mt-0.5 shrink-0" /><span>10 min walk from Kalyan Station (West side)</span></li>
            <li className="flex items-start gap-2"><Car className="h-4 w-4 mt-0.5 shrink-0" /><span>5 min drive from Khadakpada</span></li>
            <li className="flex items-start gap-2"><Car className="h-4 w-4 mt-0.5 shrink-0" /><span>15 min from Dombivli & Ambernath</span></li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default KalyanLocalSignals;